import { DataFilter } from './DataFilter';

export class PaymentProvidersFilter extends DataFilter {
    /**
     * Filter by feture name which belongs to a related data set
     * @param featureName
     * @returns {PaymentProvidersFilter}
     */
    filterByRelatedFeatureName(featureName) {
        this.filter(function (item) {
            let response = false;
            if (typeof item.features === 'object') {
                response = item.features.filter(function (features) {
                    return features.feature_name.toLowerCase() === featureName.toLowerCase();
                });
            }

            if (typeof response[0] !== 'undefined') {
                item.current_feature = response[0];
                return true;
            } else {
                return false;
            }
        });

        return this;
    }

    limit(quantity = 0) {
        let iteration = 0;

        this.filter(function (item) {
            iteration += 1;

            return iteration <= quantity || quantity === 0;
        });

        return this;
    }
}
